import * as React from "react";
import { IParagraphCartAdProps } from "./ParagraphCartAdProps";
import { Container } from "./ParagraphCartAdHelpers";
import { graphql } from "gatsby";
import CartAd from "../../common/CartAd/CartAd";

const ParagraphCartAd: React.FC<IParagraphCartAdProps> = (props) => {
  return (
    <Container className="container-sm">
      <CartAd node={props.node} />
    </Container>
  );
};

export const fragment = graphql`
  fragment ParagraphCartAd on paragraph__cart_ad {
    id
    parent_type
    field_title
    field_link {
      title
      url
    }
    field_description_formatted {
      value
      format
      processed
    }
    relationships {
      field_hotel_exclusion_list {
        crs_code
      }
      field_media {
        field_media_image {
          alt
        }
        relationships {
          field_media_image {
            gatsbyImage(
              width: 480
              height: 200
              placeholder: BLURRED
              formats: [AUTO, WEBP]
            )
          }
        }
      }
    }
  }
`;

export default ParagraphCartAd;
